"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const carabiners_1 = require("@clearsummit/carabiners");
const base_1 = __importDefault(require("./base"));
const defaults_1 = require("./defaults");
const image_1 = __importDefault(require("./image"));
class Account extends base_1.default {
    constructor(data = {
        id: undefined,
        first_name: undefined,
        last_name: undefined,
        photo: undefined,
    }) {
        super(data);
        this.first_name = (0, defaults_1.defaultString)(data.first_name);
        this.last_name = (0, defaults_1.defaultString)(data.last_name);
        this.photo = new image_1.default((0, defaults_1.defaultObject)(data.photo));
    }
    get profilePhotoUri() {
        return this.photo.url ? { uri: this.photo.url } : undefined;
    }
    get valid() {
        return !!this.id && !!this.firstName && !!this.lastName;
    }
    get fullName() {
        return (0, carabiners_1.joinStr)(this.firstName, this.lastName);
    }
    get firstName() {
        return this.firstName;
    }
    get lastName() {
        return this.firstName;
    }
}
exports.default = Account;
